import PlatformLayout from "@/layouts/PlatformLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const PlatformBillingPage = () => {
  const { user } = useAuth();

  return (
    <PlatformLayout activeTab="billing">
      <div className="p-6 max-w-4xl mx-auto" data-testid="platform-billing">
        <h1 className="text-xl font-bold text-slate-900 mb-6">Billing & Subscription</h1>

        <Card className="mb-6">
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="text-base flex items-center gap-2">
                <CreditCard className="h-4 w-4 text-blue-600" /> Current Plan
              </CardTitle>
              <Badge className="bg-emerald-500">Active</Badge>
            </div>
          </CardHeader>
          <CardContent>
            <div className="flex items-baseline gap-2 mb-4">
              <span className="text-3xl font-bold">$899</span>
              <span className="text-sm text-slate-400">/month</span>
            </div>
            <p className="text-sm text-slate-600 mb-4">Practitioner Plan — Full access to all AI tools and analytics</p>
            <div className="space-y-2">
              {[
                "Unlimited AI-powered tool usage",
                "All 40+ legal tools included",
                "Carrier Scorecard & Medical Intel",
                "Document Scanner with AI analysis",
                "PDF Export & Report Generation",
                "Priority support",
              ].map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />
                  <p className="text-sm text-slate-600">{f}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </PlatformLayout>
  );
};

export default PlatformBillingPage;
